import React from 'react';

//Custom components
import AdminPage from "UI/AppPage/AdminPage";
import KomunikatorSinglePage from "./KomunikatorSinglePage";

const AgencijeKomunikatorSinglePage = React.memo((props) => {

  return (
      <AdminPage>
        <KomunikatorSinglePage isOnUnseen={props.isOnUnseen}/>
      </AdminPage>
  );
})

export default AgencijeKomunikatorSinglePage;
